import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateCompanyUserTodo = createAsyncThunk('updateCompanyUser', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: getConfig.API_URL + `update_user/${data?.values?.id}`,
            data: {
                "id": data?.values?.id,
                "company_id": data?.values?.company_id,
                "first_name": data?.values?.first_name,
                "last_name": data?.values?.last_name,
                "email": data?.values?.email,
                "phone": data?.values?.phone,
                "role_id": data?.values?.role_id || 1,
                "type_id": data?.values?.type_id || 1,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
